import { Helmet } from "react-helmet-async";

interface SeoProps {
  title: string;
  description: string;
  path: string; // English path, e.g. "/", "/about", "/membership"
  lang: "en" | "it";
  image?: string;
}

const SITE_URL = "https://bicci-it.com";
const DEFAULT_IMAGE = "https://i.postimg.cc/B6RH8Bcz/1000016498.jpg";

export default function Seo({
  title,
  description,
  path,
  lang,
  image = DEFAULT_IMAGE,
}: SeoProps) {
  const enUrl = `${SITE_URL}${path}`;
  const itUrl = `${SITE_URL}/it${path === "/" ? "" : path}`;
  const currentUrl = lang === "it" ? itUrl : enUrl;

  return (
    <Helmet htmlAttributes={{ lang }}>
      <title>{title}</title>
      <meta name="description" content={description} />

      <link rel="canonical" href={currentUrl} />
      <link rel="alternate" hrefLang="en" href={enUrl} />
      <link rel="alternate" hrefLang="it" href={itUrl} />
      <link rel="alternate" hrefLang="x-default" href={enUrl} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:locale" content={lang === "it" ? "it_IT" : "en_US"} />
      <meta
        property="og:locale:alternate"
        content={lang === "it" ? "en_US" : "it_IT"}
      />
      <meta property="og:image" content={image} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="BICCI" />
      <meta property="og:image:alt" content={title} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image:alt" content={title} />
    </Helmet>
  );
}
